export default {
    address: {
        city: "By",
        city_locality: "By \/ lokalitet",
        country: "Land",
        line1: "Adresselinje 1",
        line2: "Adresselinje 2",
        postal_code: "Postnummer",
        state: "Delstat",
        state_region: "Stat\/region"
    },
    alerts: {
        account_2fa: "Sikre kontoen din med tofaktorautentisering.",
        account_2fa_success: "Tofaktorautentisering er aktivert.",
        activate_instruction: "Hvis du slår på automatisk innsamling av anmeldelser, vil det bli forsøkt å be om en anmeldelse fra {count}. Se malene dine før du aktiverer.",
        activate_intro: "Be kontinuerlig om anmeldelser basert på strategien din.",
        agency_mcp_server: "Koble Claude eller en hvilken som helst MCP klient til byråets MCP server. Autoriserte assistenter kan administrere byråets prosjekter, kunder og team på dine vegne.",
        ai_assistant: "Bedriftsnavnet og -beskrivelsen din er nødvendig for å bruke AI til forslag til anmeldelser og svar.",
        api_key_roll: "Er du sikker på at du vil endre API nøkkelen din? Dette vil påvirke alle applikasjoner som bruker den.",
        ask_confirm: "Er du sikker på at du vil be om anmeldelser fra {count}? Dette vil planlegge forespørsler for alle kunder som ikke har blitt spurt ennå.",
        cname_delete: "Er du sikker på at du vil fjerne CNAME: {cname_name}?",
        cname_not_configured: "Denne oppføringen er ikke konfigurert ennå. Vent litt ...",
        cname_warning: "Meldinger som allerede er sendt til kundene dine vil ha ødelagte lenker.",
        connection_disabled: "Tilkoblingen er deaktivert. Vennligst koble til på nytt.",
        customer_archive: "Er du sikker på at du vil arkivere kunden: {customer_name}? Alle usendte meldinger vil bli kansellert.",
        customer_cancel: "Er du sikker på at du vil avbryte alle usendte meldinger for kunden: {customer_name}?",
        customer_ingest: "Ta med denne e-postadressen i BCC feltet når du sender e-poster til kundene dine, slik at navn og e-postadresse importeres automatisk.",
        customer_resubscribe: "Er du sikker på at du vil abonnere kunden på nytt: {customer_name}?",
        customer_unarchive: "Er du sikker på at du vil dearkivere kunden: {customer_name}?",
        customer_unsubscribe: "Er du sikker på at du vil avslutte abonnementet til kunden: {customer_name}?",
        customer_unsubscribe_all: "Er du sikker på at du vil melde {count} av fra å motta meldinger fra dette prosjektet?",
        delete: "Er du sikker på at du vil slette {model}: {name}?",
        delete_count: "Er du sikker på at du vil slette {count}",
        domain_agency: "Legg til ditt eget avsenderdomene for å gi byrået ditt en fullstendig white label.",
        domain_delete: "Er du sikker på at du vil fjerne domenet: {name}? Vi vil fortsette å sende e-poster fra vårt eget domenenavn.",
        domain_dmarc: "Legg til en DMARC post på domenet ditt for å redusere sjansen for at e-poster havner i spam.",
        domain_project: "Legg til et avsenderdomene slik at vi kan sende e-poster til kundene dine fra ditt eget domenenavn.",
        export_confirm: "Er du sikker på at du vil eksportere alle {model}-filene dine?",
        export_count: "Er du sikker på at du vil eksportere {count}?",
        export_link: "En nedlastingslenke vil bli sendt til {email} kort tid etter at du har sendt inn forespørselen.",
        highlights_save_disabled: "Du kan eventuelt fjerne høydepunkter fra alle anmeldelser som for øyeblikket har dem.",
        highlights_save_enabled: "For å generere uthevinger for alle positive anmeldelser, merk av i boksen nedenfor. Hvis du bare endrer uthevingsfargen, lar du boksen være umerket.",
        integration_disconnect: "Er du sikker på at du vil koble fra {integration_name}?",
        integration_sync: "Er du sikker på at du vil synkronisere {integration_name}-kontoen din? Vi importerer dataene dine for deg kontinuerlig.",
        intro: "Klar til å få flere gode anmeldelser fra kundene dine? Importer kundene dine for å komme i gang. Be deretter om anmeldelser manuelt, eller trykk på Automatiser-knappen, og la anmeldelser strømme inn.",
        logout: "Er du sikker på at du vil logge ut?",
        mcp_server: "Koble Claude eller en hvilken som helst MCP klient til dette prosjektet. MCP server lar AI-assistenter lese og administrere anmeldelser, kunder og meldinger på dine vegne.",
        member_confirm: "Er du sikker på at du vil fjerne deg selv? Du vil miste tilgangen til dette prosjektet.",
        member_confirm_all: "Er du sikker på at du vil fjerne deg selv? Du vil miste tilgangen til alle prosjektene dine.",
        member_other_confirm: "Er du sikker på at du vil fjerne {noun}: {name}? De vil miste tilgangen til dette prosjektet.",
        member_other_confirm_all: "Er du sikker på at du vil fjerne {noun} {name}? De vil miste tilgang til alle prosjektene sine.",
        message_cancel: "Er du sikker på at du vil avbryte denne meldingen?",
        message_cancel_all: "Er du sikker på at du vil avbryte {count}? Denne handlingen kan bare utføres på usendte meldinger.",
        message_delete: "Er du sikker på at du vil slette denne meldingen?",
        oauth_client_revoke: "Er du sikker på at du vil tilbakekalle tilgangen for {client}? Alle aktive økter vil bli frakoblet umiddelbart.",
        project_summary: "Kan ikke generere et sammendrag for øyeblikket.",
        project_suspend: "Er du sikker på at du vil stoppe prosjektet: {project_name}?",
        project_unsuspend: "Er du sikker på at du vil oppheve suspenderingen av prosjektet: {project_name}?",
        review_delete: "Er du sikker på at du vil slette denne anmeldelsen? Denne handlingen kan ikke angres.",
        review_page_confirm: "Er du sikker på at du vil lagre endringene dine?",
        review_page_default: "Er du sikker på at du vil gjøre anmeldelsessiden {name} til standardsiden din? Denne siden vil bli brukt hvis ingen annen side er tilordnet en anmeldelsesforespørsel.",
        review_page_delete: "Er du sikker på at du vil slette anmeldelsessiden: {name}? Alle kunder som for øyeblikket blir sendt til denne siden, vil bli sendt til standardsiden din.",
        review_page_delete_all: "Er du sikker på at du vil slette {count}? Standard anmeldelsessiden din vil ikke bli slettet.",
        review_page_fields: "Bruk felt for å samle inn kundeinformasjon når du legger igjen en anmeldelse. Legg til flere felt i skjemaet ditt og vis dem betinget når kunder velger en vurdering.",
        review_page_instructions: "Vis instruksjoner rett over skjemaet etter at en vurdering er valgt.",
        review_page_location_picker: "La kundene velge et hvilket som helst sted i prosjektet ditt for anmeldelsen. Dette vil være forhåndsvalgt hvis Anmeldelsessiden er ment å vises for et bestemt sted.",
        review_page_locations: "Velg stedene som skal bruke denne anmeldelsessiden. Et sted kan bare tilordnes én anmeldelsesside. Hvis et sted ikke er tilordnet en, vil det bruke standard anmeldelsesside.",
        review_page_redirects: "Hopp over skjemaet etter at en vurdering er valgt, og omdiriger andre steder. Du kan også dele trafikken til flere nettsteder ved å legge til mer enn én omdirigering for hver vurdering.",
        share_template_delete: "Er du sikker på at du vil slette delingsmalen «{name}»? Dette kan ikke angres.",
        smtp_remove: "Er du sikker på at du vil fjerne SMTP konfigurasjonen fra prosjektet ditt? Avsenderdomenet ditt vil gå tilbake til standardkonfigurasjonen.",
        smtp_setup: "Send e-post fra din egen e-postserver. Skriv inn SMTP legitimasjonen din. Hvis serveren din bruker IP-begrensninger, vennligst hvitliste følgende IP-adresser som brukes av systemet vårt: {ips}.",
        space_delete: "Er du sikker på at du vil slette arbeidsområde: {name}? Alle prosjekter i det vil bli slettet.",
        tag_rule: "Legg til et positivt begrep og dets negative motstykke. Hvis det gjelder, bruker vi AI til å automatisk tagg anmeldelsen med det ene eller det andre.",
        user_delete: "Er du sikker på at du vil slette brukerkontoen for: {email}?",
        user_verify: "For å bekrefte e-postadressen din og aktivere kontoen din, klikk på lenken i e-posten som ble sendt til: {email}.",
        widget_delete: "Er du sikker på at du vil slette widgeten: {name}? Widgeten vil ikke lenger vises på noen nettsteder.",
        widget_restore: "Er du sikker på at du vil gjenopprette innstillingene for widgeten: {name}? Bare designet vil gå tilbake til standardverdiene.",
        widgets_1: "Legg til dette skriptet i nettsidens brødtekst.",
        widgets_2: "Anmeldelsesveggen viser alle anmeldelsene dine som et rutenett. Legg til dette skriptet der du vil at widgeten skal vises.",
        widgets_3: "Fremhevet anmeldelse viser én stor anmeldelse. Legg til dette skriptet der du vil at widgeten skal vises."
    },
    billing_statuses: {
        active: "Abonnementet ditt er aktivt.",
        canceled: "Abonnementet ditt er kansellert. Oppgrader for å fortsette.",
        ending: "Abonnementet ditt avsluttes {date}.",
        trial: "Din gratis prøveperiode avsluttes {date}.",
        trial_expired: "Din gratis prøveperiode er over. Vennligst oppgrader for å fortsette.",
        trial_expiring: "Den gratis prøveperioden din er snart over. Vennligst oppgrader for å fortsette."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-post",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messenger",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Legg til et avsenderdomene for å redigere e-postadressen din:",
        agency_robots: "Tillat søkemotorer å indeksere kundeportalen din.",
        ai_business_description: "En detaljert beskrivelse av virksomheten din for å hjelpe med å generere forslag til anmeldelser og svar.",
        ai_business_name: "Navnet på bedriften din.",
        ask_location: "Plasseringen som skal tilordnes til anmeldelsen.",
        ask_review_page: "Siden for å registrere anmeldelsen.",
        assign_tags: "Tildel tagger til anmeldelsen.",
        csv_max_rows: "Opptil {count} rader",
        dashboard_configure_settings: "Konfigurer prosjektinnstillingene dine.",
        dashboard_import_customers: "Importer kundene dine.",
        dashboard_preview_email_templates: "Forhåndsvis e-postmalene dine.",
        dashboard_preview_kiosk_page: "Forhåndsvis kiosksiden din.",
        dashboard_preview_review_page: "Forhåndsvis anmeldelsessiden din.",
        dashboard_preview_showcase_page: "Forhåndsvis presentasjonssiden din.",
        logo_height: "Høyden på logoen på e-poster og sider.",
        meta_description: "Overstyr sidebeskrivelsen.",
        meta_title: "Overstyr sidetittelen.",
        mfa_password: "Skriv inn kontopassordet ditt.",
        mfa_qr_code: "Skann QR-koden med autentiseringsappen din.",
        mfa_security_code: "Skriv inn koden fra autentiseringsappen din.",
        override_ambassador: "Vis et merke på kundenes e-poster, sider og widgeter.",
        project_name: "Navnet på bedriften, merkevaren eller nettstedet ditt.",
        project_robots: "Tillat søkemotorer å indeksere anmeldelsessidene dine og vise frem dem.",
        setup_basics: "Bestem når og hvordan du ber kunder om anmeldelser.",
        setup_business: "Fortell oss navnet kundene kjenner deg under.",
        setup_google: "Send kunder til Google profilen din, svar på anmeldelser og importer eksisterende. Du kan hoppe over dette og gjøre det senere.",
        setup_location_limit: "Prøveperioden din inkluderer én lokasjon. Oppgrader når som helst for å synkronisere mer.",
        project_slug: "Brukes i kundevendte e-poster og lenker hvis et CNAME ikke er konfigurert.",
        review_page_copied_message: "Vises etter at en positiv anmeldelse er sendt inn.",
        review_page_email_address: "Motta anmeldelser på denne e-postadressen.",
        review_page_link_reveal_position: "Hvor man skal avsløre lenkene.",
        review_page_link_revealer_label: "Etiketten for å avsløre lenkene.",
        review_page_link_revealer_rating: "Vis lenker hvis kunden velger denne vurderingen eller høyere, ellers vis en knapp for å vise dem.",
        review_page_native_reviews: "Tillat anmeldelser på denne plattformen.",
        review_page_rating_selection: "Lagre vurdering før en anmeldelse sendes inn.",
        review_page_success_button_link: "Hvis den er tom, er lenken som standard til prosjektets nettsted, ellers domenet til siden.",
        review_page_warning: "Å hindre kunder i å legge igjen offentlige anmeldelser kan føre til at bedriftsoppføringen din fjernes.",
        review_reply_status: "Vi kan ikke svare offentlig på denne anmeldelsen. Du kan kontakte anmelderen direkte i stedet.",
        review_suggestions: "Hjelp kunder med å skrive anmeldelser.",
        separate_with_commas: "Skill flere med komma.",
        showcase_locations: "Begrens presentasjonen til bestemte steder.",
        showcase_review_length: "Anmeldelser må ha minst dette antallet tegn.",
        showcase_since: "Vis anmeldelser som er opprettet på eller før denne datoen.",
        showcase_sources: "Begrens presentasjonen til bestemte kilder.",
        showcase_tags: "Begrens presentasjonen til anmeldelser med spesifikke tagger.",
        signature_html: "Kopier og lim inn signatur i e-postprogrammet ditt.",
        signed_up: "Kundens startdato.",
        twilio_webhook: "Angi som tilbakeringings- URL for meldingstjenesten din.",
        widget_embed: "ID attributtet til div-beholderen der widgeten skal vises."
    },
    labels: {
        accept_all: "Godta alle",
        access_code: "Tilgangskode",
        access_codes: "Tilgangskoder",
        account: "Konto",
        account_sid: "Konto SID",
        action: "Handling",
        actions: "Handlinger",
        activate: "Aktiver",
        active: "Aktiv",
        active_subscription: "Aktivt abonnement",
        add: "Legge til",
        add_agency_project: "Legg til et byråprosjekt",
        add_confirmation_message: "Legg til en bekreftelsesmelding.",
        add_css_rules: "Legg til dine egne CSS-regler.",
        add_custom_field: "Legg til tilpasset felt",
        add_customer: "Legg til en kunde",
        add_customers_with: "Legg til kunder med {model}",
        add_external_link: "Legg til en ekstern Lenke",
        add_external_links: "Legg til eksterne Lenker",
        add_introduction: "Legg til en introduksjon.",
        add_js_tags: "Legg til dine egne JavaScript tagger.",
        add_legal_information: "Legg til juridisk informasjon.",
        add_location: "Legg til en plassering",
        add_project: "Legg til et prosjekt",
        add_review: "Legg til en Anmeldelse",
        add_source: "Legg til en kilde",
        add_tag: "Legg til en Tagg",
        added: "Lagt til",
        address: "Adresse",
        advanced_review_pages: "Avanserte Anmeldelsessider",
        affiliates: "Tilknyttede selskaper",
        age_of_reviews: "Alderen på Anmeldelser",
        agency: "Byrå",
        agency_name: "Byrånavn",
        agency_project: "Byråprosjekt",
        agency_projects: "Byråprosjekter",
        ai: "AI",
        ai_answers: "AI-svar",
        ai_assistant: "AI-assistent",
        ai_auto_tagging: "AI automatisk tagging",
        ai_reviews_and_replies: "Forslag og svar på AI-Anmeldelse",
        ai_tagging_instructions: "Eksempel: Gjelder anmeldelser som nevner ventetider, treg service eller forsinkelser.",
        all: "Alle",
        allowed_domains: "Tillatte domener",
        amount: "Beløp",
        analytics: "Analyse",
        and: "og",
        anonymous_reviews: "Anonyme Anmeldelser",
        answer: "Svare",
        any: "Noen",
        api: "API",
        api_key: "API nøkkel",
        appearance: "Utseende",
        approved: "Godkjent",
        archive: "Arkiv",
        archive_customer: "Arkivkunde",
        archived: "Arkivert",
        at_least: "i det minste",
        at_least_days: "Minst {num} dager",
        at_least_hours: "Minst {num} timer",
        at_least_months: "Minst {num} måneder",
        at_most: "på det meste",
        at_most_days: "Maksimalt {num} dager",
        at_most_hours: "Maksimalt {num} timer",
        at_most_months: "Maksimalt {num} måneder",
        auth_token: "Autorisasjonstoken",
        authorize: "Autorisere",
        auto_detect: "Automatisk oppdaging",
        auto_tags: "Automatiske tagger",
        automate: "Automatiser",
        automate_highlights: "Automatiser uthevinger",
        automate_replies: "Automatiser svar",
        automatic_review_collection: "Automatisk innsamling av Anmeldelse",
        automatically_apply_tags: "Bruk tagg automatisk på eksisterende anmeldelser",
        automating: "Automatisering",
        avatar: "Avatar",
        avatars: "Avatarer",
        average_charge: "Gjennomsnittlig kostnad",
        average_review: "Gjennomsnittlig Anmeldelse",
        background_color: "Bakgrunnsfarge",
        background_image: "Bakgrunnsbilde",
        back: "Tilbake",
        bcc: "BCC",
        bcc_email_address: "BCC -e-postadresse",
        best_to_worst: "Best til verst",
        billing: "Fakturering",
        blog: "Blogg",
        body: "Tekst",
        body_font_size: "Skriftstørrelse for Tekst",
        bold: "Fet",
        bottom: "Bunn",
        bottom_left: "Nederst til venstre",
        bottom_right: "Nederst til høyre",
        build_on: "Bygg på {model}",
        business: "Business",
        business_description: "Bedriftsbeskrivelse",
        business_email: "E-postadresse for brukerstøtte",
        business_name: "Firmanavn",
        business_phone: "Telefonnummer for kundestøtte",
        business_website: "Bedriftsnettsted",
        button: "Knapp",
        button_label: "Etikett for Knapp",
        button_link: "Lenke til Knapp",
        button_position: "Knapp posisjon",
        button_size: "Størrelse på Knapp",
        buy_me_a_coffee: "Kjøp meg en kaffe",
        by: "ved",
        by_signing_up: "Ved å opprette en konto godtar du våre",
        call_to_action: "Handlingsoppfordring",
        cancel: "Kansellere",
        cancel_1_message: "Avbryt 1 melding",
        cancel_message: "Avbryt melding",
        cancel_messages: "Avbryt {count} Meldinger",
        cancel_subscription: "Avbryt abonnementet",
        cancel_unsent_messages: "Avbryt usendte meldinger",
        canceled: "Avlyst",
        center: "Senter",
        change: "Endre",
        change_key: "Endre API nøkkelen din",
        change_plan: "Endringsplan",
        changelog: "Endringslogg",
        channel: "Kanal",
        channels: "Kanaler",
        characters: "Tegn",
        charges_avg: "Gjennomsnittlig kostnad må være minst",
        charges_count: "Antall belastninger må være minst",
        charges_sum: "Totale kostnader må være minst",
        chat_with_us: "Chat med oss",
        checkbox: "Avkrysningsboks",
        claude: "Claude",
        clear: "Klar",
        clear_highlights_from_reviews: "Fjern høydepunkter fra alle anmeldelser",
        clicked: "Klikket",
        client: "Klient",
        clients: "Klienter",
        close: "Lukke",
        cloudflare_warning: "Hvis du bruker Cloudflare, må proxyen din være slått av.",
        cname: "CNAME",
        cname_setup_incomplete: "Oppsettet er ikke fullført – vil bli fjernet {date}",
        cname_ssl_pending: "Venter på SSL-sertifikat",
        cname_status_for: "CNAME status for",
        code_editor: "Koderedigerer",
        collapse: "Minimer",
        collect_reviews_anywhere: "Samle anmeldelser hvor som helst",
        color: "Farge",
        colors: "Farger",
        commission_rate: "Provisjonssats",
        commission_status_approved: "Godkjent",
        commission_status_paid: "Betalt",
        commission_status_pending: "I påvente av",
        commission_status_reversed: "Omvendt",
        community: "Fellesskap",
        company: "Bedrift",
        complained: "Klaget",
        confirm_new_password: "Bekreft nytt passord",
        confirmation_message: "Bekreftelsesmelding",
        connect: "Koble til",
        connect_bank: "Koble til bankkonto",
        connect_google: "Koble til Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Tilkoblet",
        consent_preferences: "Samtykkeinnstillinger",
        contact_customer: "Kontakt kunde",
        contact_support: "Vennligst kontakt kundestøtte.",
        contact_us: "Kontakt oss",
        container_element: "Beholderelement",
        context: "Kontekst",
        continue: "Fortsette",
        continue_with_google: "Fortsett med Google",
        cookie_category_analytics: "Analyse",
        cookie_category_essential: "Viktig",
        cookie_category_functional: "Funksjonell",
        cookie_category_marketing: "Markedsføring",
        cookie_consent_banner: "Banner for samtykke til informasjonskapsler",
        cookie_consent_scope_all: "Vis til alle",
        cookie_consent_scope_eea: "Vises kun for besøkende i EØS og Storbritannia",
        cookie_consent_scope_none: "Ikke vis",
        cookie_policy: "Informasjonskapsler",
        cookie_preference: "Informasjonskapselpreferanse",
        copied: "Kopiert",
        copied_message: "Kopiert melding",
        copy: "Kopiere",
        copy_embed_code: "Kopier innebyggingskode",
        copy_signature: "Kopier Signatur",
        copy_source_code: "Kopier kildekode",
        copy_uuid: "Kopier UUID",
        create: "Skape",
        create_account: "Opprett konto",
        create_agency: "Opprett et byrå",
        create_cname: "Opprett en CNAME post og pek den til",
        create_external_link: "Opprett en ekstern Lenke",
        create_field: "Opprett et felt",
        create_link: "Opprett en Lenke",
        create_location: "Opprett en plassering",
        create_project: "Opprett et prosjekt",
        create_qr_code: "Lag QR-kode",
        create_review: "Opprett en Anmeldelse",
        create_review_page: "Opprett en Anmeldelsesside",
        create_signature: "Lag en signatur",
        create_source: "Opprett en kilde",
        create_space: "Opprett et Arbeidsområde",
        create_tag: "Opprett en Tagg",
        create_tag_rule: "Opprett en taggregel",
        create_webhook: "Opprett en webhook",
        create_widget: "Opprett en widget",
        crms: "CRM-systemer",
        csv: "CSV",
        currency: "Valuta",
        current_plan: "Gjeldende plan",
        current_year: "Inneværende år",
        custom_field: "Tilpasset felt",
        custom_instructions: "Tilpassede instruksjoner",
        custom_url: "Tilpasset URL",
        customer: "Kunde",
        customer_name_convention: "Kundenavnkonvensjon",
        customer_reviews: "Anmeldelser",
        customers: "Kunder",
        customize: "Tilpass",
        customize_review_page: "Tilpass Anmeldelsesside",
        daily: "Daglig",
        daily_email_requests: "Daglige e-postforespørsler",
        daily_limit: "Daglig grense",
        daily_requests: "Daglige forespørsler",
        daily_sms_requests: "Daglige SMS forespørsler",
        dark: "Mørk",
        dashboard: "Kontrollpanel",
        date: "Dato",
        date_added: "Dato lagt til",
        date_canceled: "Dato avlyst",
        date_clicked: "Dato klikket",
        date_complained: "Dato klaget",
        date_delivered: "Leveringsdato",
        date_failed: "Dato mislyktes",
        date_messaged: "Dato sendt med melding",
        date_opened: "Dato åpning",
        date_replied: "Dato svart",
        date_requested: "Forespurt dato",
        date_reviewed: "Dato Anmeldt",
        date_scheduled: "Planlagt dato",
        date_sent: "Sendt dato",
        date_signed_up: "Dato for påmelding",
        date_updated: "Dato oppdatert",
        dates: "Datoer",
        day: "Dag",
        days: "Dager",
        days_after_last_request: "dager etter siste forespørsel",
        days_later: "dager senere",
        deactivate: "Deaktiver",
        default: "Standard",
        default_language: "Standardspråk",
        default_review_page: "Standard Anmeldelsesside",
        default_review_visibility: "Standard synlighet for Anmeldelse",
        default_tone: "Standardtone",
        delay: "Utsette",
        delete: "Slett",
        delete_1_customer: "Slett 1 kunde",
        delete_1_review: "Slett 1 Anmeldelse",
        delete_1_review_page: "Slett 1 Anmeldelsesside",
        delete_1_widget: "Slett 1 widget",
        delete_agency: "Slett byrå",
        delete_custom_field: "Slett tilpasset felt",
        delete_customer: "Slett kunde",
        delete_customers: "Slett kunder",
        delete_external_link: "Slett ekstern Lenke",
        delete_field: "Slett felt",
        delete_link: "Slett Lenke",
        delete_location: "Slett plassering",
        delete_message: "Slett melding",
        delete_n_customers: "Slett {count} Kunder",
        delete_n_review_pages: "Slett {count} Anmeldelsessider",
        delete_n_reviews: "Slett {count} Anmeldelser",
        delete_n_widgets: "Slett {count}-widgeter",
        delete_project: "Slett prosjekt",
        delete_qr_code: "Slett QR-kode",
        delete_reply: "Slett svar",
        delete_review: "Slett Anmeldelse",
        delete_review_page: "Slett Anmeldelsesside",
        delete_review_pages: "Slett Anmeldelsessider",
        delete_reviews: "Slett Anmeldelser",
        delete_signature: "Slett Signatur",
        delete_source: "Slett kilde",
        delete_space: "Slett Arbeidsområde",
        delete_tag: "Slett Tagg",
        delete_tag_rule: "Slett taggregel",
        delete_template: "Slett mal",
        delete_user: "Slett bruker",
        delete_webhook: "Slett webhooken",
        delete_widget: "Slett widget",
        delete_widgets: "Slett widgeter",
        deleted: "Slettet",
        delivered: "Levert",
        description: "Beskrivelse",
        deselect_all: "Fjern merkingen av alle",
        disable: "Deaktiver",
        disable_automatic_review_collection: "Deaktiver automatisk innsamling av Anmeldelse",
        disable_field: "Deaktiver felt",
        disable_when_links_are_visible: "Deaktiver når lenker er synlige",
        disabled: "Deaktivert",
        disconnect: "Frakople",
        disconnect_integration: "Koble fra integrasjonen",
        discord_community: "Discord fellesskapet",
        display_name: "Visningsnavn",
        dmarc: "DMARC",
        dmarc_status_for: "DMARC status for",
        do_not_hide_from_public: "Ikke skjul deg for offentligheten",
        do_not_send: "Ikke send",
        documentation: "Dokumentasjon",
        domain: "Domene",
        domain_name: "Domenenavn",
        dont_have_an_account: "Har du ikke en konto?",
        dont_send_thanks: "Ikke send takk",
        download: "Last ned",
        download_records: "Last ned poster",
        download_template: "Last ned mal",
        dpa: "DPA",
        dsar: "DSAR",
        duplicate: "Dupliser",
        duplicate_project: "Duplikatprosjekt",
        duplicate_review_page: "Duplikat Anmeldelsesside",
        duplicate_reviews: "Dupliserte Anmeldelser",
        duplicate_widget: "Dupliser widget",
        edit: "Redigere",
        edit_1_customer: "Rediger 1 kunde",
        edit_1_review: "Rediger 1 Anmeldelse",
        edit_client: "Rediger Klient",
        edit_custom_field: "Rediger tilpasset felt",
        edit_customer: "Rediger kunde",
        edit_customers: "Rediger kunder",
        edit_field: "Rediger felt",
        edit_link: "Rediger Lenke",
        edit_location: "Rediger plassering",
        edit_member: "Rediger medlem",
        edit_n_customers: "Rediger {count} Kunder",
        edit_n_reviews: "Rediger {count} Anmeldelser",
        edit_notes: "Rediger notater",
        edit_qr_code: "Rediger QR-kode",
        edit_reviews: "Rediger Anmeldelser",
        edit_signature: "Rediger Signatur",
        edit_source: "Rediger kilde",
        edit_strategy: "Rediger strategi",
        edit_tag: "Rediger Tagg",
        edit_tag_rule: "Rediger Tagg",
        edit_team_member: "Rediger teammedlem",
        edit_visibility: "Rediger synlighet",
        edit_webhook: "Rediger webhook",
        editable_ratings: "Redigerbare vurderinger",
        earned: "Opptjent",
        eligible: "Berettiget",
        email: "E-post",
        email_address: "E-postadresse",
        email_validation_invalid: "E-postvalidering mislyktes",
        email_validation_passed: "E-postvalidering bestått",
        email_validation_unknown: "E-postadressen kunne ikke bekreftes",
        emails: "E-poster",
        embed_code: "Innbyggingskode",
        enable: "Aktiver",
        enable_automatic_review_collection: "Aktiver automatisk innsamling av Anmeldelse",
        enable_for_all_reviews: "Aktiver for alle anmeldelser",
        enable_for_positive_reviews: "Aktiver for positive anmeldelser",
        enable_on_review_pages: "Aktiver på anmeldelsessider",
        enabled: "Aktivert",
        end: "Slutt",
        ends: "Slutter",
        exclude: "Utelukke",
        exclude_email: "Ekskluder e-post",
        exclude_sms: "Ekskluder SMS",
        excluded_channels: "Ekskluderte kanaler",
        expand: "Utvide",
        expired: "Utløpt",
        export: "Eksport",
        export_1_customer: "Eksporter 1 kunde",
        export_1_review: "Eksporter 1 Anmeldelse",
        export_all: "Eksporter alle",
        export_all_customers: "Eksporter alle kunder",
        export_all_reviews: "Eksporter alle Anmeldelser",
        export_customers: "Eksportkunder",
        export_n_customers: "Eksporter {count} Kunder",
        export_n_reviews: "Eksporter {count} Anmeldelser",
        export_reviews: "Anmeldelser",
        external_link: "Ekstern Lenke",
        external_links: "Eksterne Lenker",
        extra_locations: "Ekstra lokasjoner",
        faces: "Ansikter",
        failed: "Mislyktes",
        feedback: "Tilbakemelding",
        field: "Felt",
        fields: "Felt",
        filter: "Filter",
        first: "Først",
        first_charged: "Førstegangsbelastet",
        first_name: "Fornavn",
        first_name_last_initial: "Fornavn, etternavn initial",
        flag_as_duplicate: "Flagg som duplikat",
        font: "Skrifttype",
        font_family: "Skriftfamilie",
        font_size: "Skriftstørrelse",
        footer: "Bunntekst",
        for: "Til",
        forgot_password: "Glemt passord",
        form: "Skjema",
        free: "Gratis",
        free_requests_included: "Gratis forespørsler inkludert",
        from: "fra",
        full_name: "Fullt navn",
        generate: "Generere",
        generate_meta: "Generer metadata",
        generate_qr_code: "Generer QR-kode",
        generate_reply: "Generer svar",
        generate_review: "Generer Anmeldelse",
        generating: "Genererer",
        get_started: "Kom i gang",
        get_started_checklist: "Sjekkliste for å komme i gang",
        get_the_lifetime_deal: "Få livstidstilbudet",
        getting_started: "Komme i gang",
        google_fonts: "Google -fonter",
        grouped_by_request: "Gruppert etter forespørsel",
        has_links: "Har Lenker",
        has_notes: "Har notater",
        has_redirects: "Har omdirigeringer",
        have_an_account: "Har du en konto?",
        header: "Overskrift",
        hidden: "Skjult",
        hidden_from_search_engines: "Skjult fra søkemotorer",
        hidden_reviews: "Skjulte Anmeldelser",
        hide: "Gjemme",
        hide_all_reviews: "Skjul alle anmeldelser",
        hide_avatar: "Skjul avataren",
        hide_date: "Skjul dato",
        hide_drop_shadow: "Skjul skyggeeffekt",
        hide_field_label: "Skjul feltetikett",
        hide_from_public: "Skjul fra offentligheten",
        hide_name: "Skjul navn",
        hide_pagination: "Skjul paginering",
        highlight_color: "Uthevingsfarge",
        host: "Vert",
        hours: "Timer",
        icon: "Ikon",
        icon_size: "Ikonstørrelse",
        icons: "Ikoner",
        id: "ID",
        image: "Bilde",
        import: "Import",
        import_address1: "Kundens adresselinje 1.",
        import_address2: "Kundens adresselinje 2.",
        import_city: "Kundens by eller lokalitet.",
        import_company: "Kundens firmanavn.",
        import_created_at: "Datoen for anmeldelsen.",
        import_customers: "Importer kunder",
        import_email: "Kundens e-postadresse.",
        import_first_name: "Kundens fornavn.",
        import_from_boost_space: "Importer fra Boost.space",
        import_from_facebook: "Importer fra Facebook",
        import_from_google: "Importer fra Google",
        import_from_hubspot: "Importer fra HubSpot",
        import_from_make_com: "Importer fra Make.com",
        import_from_pabbly: "Importer fra Pabbly",
        import_from_stripe: "Importer fra Stripe",
        import_from_zapier: "Importer fra Zapier",
        import_last_name: "Kundens etternavn.",
        import_list: "Kommaseparert liste over",
        import_notes: "Merknader kun for intern bruk.",
        import_phone: "Kundens telefonnummer.",
        import_postal_code: "Kundens postnummer.",
        import_recent_reviews: "Importer nylige Anmeldelser",
        import_review: "Anmeldelsesteksten.",
        import_reviews: "Importer Anmeldelser",
        import_score: "Vurderingen fra 1–5.",
        import_signed_up_at: "Kundens startdato.",
        import_slug: "slug eller UUID en til en",
        import_state: "Kundens stat eller region.",
        incentive: "Insentiv",
        include: "Inkludere",
        include_sample_reviews: "Inkluder anmeldelser",
        incoming_webhook_url: "Innkommende Webhook- URL",
        inherit: "Arve",
        initializing: "Initialiserer",
        initials: "Initialer",
        insert_variable: "Sett inn variabel",
        instructions: "Instruksjoner",
        integration: "Integrering",
        integrations: "Integrasjoner",
        interval: "Intervall",
        introduction: "Introduksjon",
        invite: "Invitere",
        invite_client: "Inviter Klient",
        invite_failed: "Invitasjonen mislyktes",
        invite_member: "Inviter medlem",
        invite_sent_to: "Invitasjon sendt til",
        invite_team_member: "Inviter teammedlem",
        invited: "Invitert",
        italic: "Kursiv",
        joined: "Ble med",
        key: "Nøkkel",
        keywords: "Nøkkelord",
        keywords_in_replies: "Nøkkelord i svar",
        keywords_in_reviews: "Nøkkelord i Anmeldelser",
        kiosk_page: "Kioskside",
        label: "Merkelapp",
        label_font_size: "Skriftstørrelse for etikett",
        labels: "Etiketter",
        language: "Språk",
        languages: "Språk",
        large: "Stor",
        last_charged: "Sist belastet",
        last_name: "Etternavn",
        layout: "Oppsett",
        leave: "Forlate",
        leave_project: "Forlat prosjektet",
        leave_space: "Forlat Arbeidsområde",
        left: "Venstre",
        less: "mindre",
        lifecycle_stage: "Livssyklusfase",
        lifetime_deal: "Livstidsavtale",
        light: "Lys",
        limit: "Begrense",
        limits: "Grenser",
        link: "Lenke",
        link_color: "Lenkkefarge",
        link_reveal_position: "Posisjon for avsløring av Lenke",
        link_revealer_button: "Knapp for å vise Lenke",
        link_revealer_label: "Etikett for Lenke",
        link_revealer_rating: "Vurdering av Lenke Revealer",
        links: "Lenker",
        links_per_review_page: "Lenker per Anmeldelsesside",
        list: "Liste",
        list_unsubscribe_headers: "Overskrifter for List-Unsubscribe",
        load_more: "Last inn mer",
        loading: "Laster",
        location: "Sted",
        location_address: "Stedsadresse",
        location_name: "Stedsnavn",
        location_picker: "Stedsvelger",
        locations: "Steder",
        locations_limit: "Lokasjonsgrense",
        log_in: "Logg inn",
        log_out: "Logg ut",
        logo: "Logo",
        logo_height: "Logohøyde",
        long: "Lang",
        lowest_rating: "Laveste vurdering",
        ltd: "LTD",
        make_default: "Gjør til standard",
        manage: "Administrer",
        manage_limits: "Administrer grenser",
        manage_overrides: "Administrer overstyringer",
        manage_payout_account: "Administrer utbetalingskonto",
        manage_subscription: "Administrer abonnement",
        manual_entry: "Manuell inntasting",
        max: "Maks",
        max_size: "Maksimal størrelse",
        maximum_characters: "Maksimalt Tegn",
        maximum_customers: "Maksimalt antall kunder",
        maximum_locations: "Maksimalt antall plasseringer",
        maximum_members: "Maksimalt antall medlemmer",
        maximum_review_length: "Maksimal Anmeldelse",
        maximum_tags: "Maksimalt Tagger",
        maximum_widgets: "Maksimalt antall widgeter",
        mcp: "MCP Server",
        mcp_server: "MCP Server",
        mcp_server_url: "MCP Server URL",
        medium: "Medium",
        member: "Medlem",
        members: "Medlemmer",
        menu: "Meny",
        message: "Beskjed",
        message_link_expiration: "Utløp for meldingslenke",
        messaged: "Sendt melding",
        messages: "Meldinger",
        messages_clicked: "Meldinger klikket på",
        messages_sent: "Sendte meldinger",
        messaging_service_sid: "Meldingstjeneste- SID",
        min: "Min.",
        min_size: "Min. størrelse",
        minimal_delay: "Minimal forsinkelse",
        minimum_characters: "Minimum Tegn",
        minutes: "Minutter",
        month: "måned",
        monthly: "Månedlig",
        monthly_email_requests: "Månedlige e-postforespørsler",
        monthly_limit: "Månedlig grense",
        monthly_pricing_only: "Kun månedlig prising",
        monthly_request_limit: "Månedlig forespørselsgrense",
        monthly_requests: "Månedlige forespørsler",
        monthly_sms_requests: "Månedlige SMS forespørsler",
        months: "Måneder",
        months_free: "{count} Måneder Gratis",
        more: "flere",
        more_clients: "flere kunder",
        more_customers: "flere kunder",
        more_options: "Flere alternativer",
        more_patients: "flere pasienter",
        more_reviews: "flere anmeldelser",
        more_reviews_needed: "Flere anmeldelser er nødvendige for å oppsummere",
        more_users: "flere brukere",
        more_visitors: "flere besøkende",
        move: "Flytte",
        moved: "Flyttet",
        name: "Navn",
        native_reviews: "Native Anmeldelser",
        negative_term: "Negativt begrep",
        negative_trends: "Negative trender",
        new: "Ny",
        new_password: "Nytt passord",
        no: "Ingen",
        no_available_options: "Ingen tilgjengelige alternativer",
        no_credit_card_required: "Ingen kredittkort kreves",
        no_data_available: "Ingen data tilgjengelig",
        no_negative_trends: "Ingen negative trender ennå",
        no_positive_trends: "Ingen positive trender ennå",
        no_reminders: "Ikke send påminnelser",
        no_retries: "Ingen nye forsøk",
        no_review: "Ingen anmeldelse",
        none: "Ingen",
        not_connected: "Ikke tilkoblet",
        not_reviewed: "Ikke Anmeldt",
        notes: "Notater",
        notifications: "Varsler",
        now: "Nå",
        number_of_charges: "Antall kostnader",
        number_of_reminders: "Antall påminnelser",
        number_of_retries: "Antall nye forsøk",
        number_of_review_suggestions: "Antall forslag til Anmeldelse",
        of: "av",
        off: "Av",
        on: "På",
        on_channel: "på kanal {channel}.",
        opened: "Åpnet",
        options: "Alternativer",
        or_log_in_with_email: "eller logg inn med e-postadressen din",
        or_sign_up_with_email: "eller bruk e-postadressen din",
        our_reviews: "Våre Anmeldelser",
        output: "Produksjon",
        page_footer: "Sidebunntekst",
        paid: "Betalt",
        paragraph: "Avsnitt",
        password: "Passord",
        past_month: "Forrige måned",
        past_months: "Siste {inc} måneder",
        past_week: "Forrige uke",
        past_year: "Siste år",
        past_years: "Siste {inc} år",
        paused: "Pauset",
        payment_method: "Betalingsmåte",
        payout_status_completed: "Fullført",
        payout_status_pending: "I påvente av",
        pending: "I påvente av",
        pending_deployment: "Venter på distribusjon",
        pending_validation: "Venter på validering",
        per_day: "per dag",
        per_month: "per måned",
        permissions: "Tillatelser",
        phone: "Telefon",
        phone_number: "Telefonnummer",
        pixels: "piksler",
        placeholder: "Plassholder",
        placement: "Plassering",
        plan: "Plan",
        plan_bullet1: "Fjern merkevarebyggingen vår på e-poster, sider og widgeter",
        plan_bullet2: "Bruk domenet ditt for kundevendte sider og e-postsending",
        plan_bullet3: "Gjør produktet ditt eget med hvit merking for byråer",
        please_rate_our_service: "Vennligst vurder tjenesten vår",
        png: "PNG",
        policies: "Retningslinjer",
        popular: "Populær",
        port: "Port",
        position: "Posisjon",
        positive_only: "Kun positive Anmeldelser",
        positive_term: "Positivt begrep",
        positive_trends: "Positive trender",
        powered_by: "Drevet av",
        preview: "Forhåndsvisning",
        preview_kiosk_page: "Forhåndsvisning av kioskside",
        preview_review_page: "Forhåndsvisning av Anmeldelsesside",
        price: "Pris",
        pricing: "Prissetting",
        primary_color: "Primærfarge",
        priority: "Prioritet",
        privacy_policy: "Personvernerklæring",
        proceed_to_dashboard: "Gå til Kontrollpanel",
        product: "Produkt",
        profile: "Profil",
        project: "Prosjekt",
        project_name: "Prosjektnavn",
        setup_ask_delay: "Hvor lenge bør man vente før man ber om en anmeldelse",
        setup_reminders: "Hvor mange påminnelser som skal sendes",
        project_paused: "Dette prosjektet er satt på pause.",
        project_suspended: "Dette prosjektet er suspendert.",
        project_website: "Prosjektnettsted",
        projects: "Prosjekter",
        projects_limit: "Prosjektgrense",
        publish: "Utgi",
        publish_changes: "Publiser endringene på alle andre Anmeldelsessider",
        published: "Publisert",
        purchase: "Kjøpe",
        qr_code: "QR-kode",
        qr_code_name_placeholder: "Bord 1, Resepsjon",
        qr_codes: "QR-koder",
        quantity: "Mengde",
        query: "Spørsmål",
        quick_import: "Hurtigimport",
        rating: "Vurdering",
        rating_order: "Vurderingsrekkefølge",
        rating_out_of: "vurdering ut av",
        rating_save_all: "Lagre vurdering før hver anmeldelse",
        rating_save_customer: "Lagre vurdering før en kundeanmeldelse",
        rating_save_never: "lagre aldri vurdering før anmeldelse",
        rating_selection: "Valg av vurdering",
        rating_selector: "Vurderingsvelger",
        ratings: "Vurderinger",
        read: "Lese",
        reapply_highlights_eligible: "Regenerer høydepunkter med AI for alle positive anmeldelser",
        reconnect: "Koble til igjen",
        redeem: "Løs inn",
        redirects: "Omdirigeringer",
        refer_and_earn: "Henvis og tjen penger",
        referral_billing_status_active: "Abonnerer",
        referral_billing_status_canceled: "Avlyst",
        referral_billing_status_trial: "Prøve",
        referral_billing_status_trial_expired: "Prøveperioden er utløpt",
        referral_billing_status_trial_expiring: "Prøveperioden utløper",
        referral_program: "Vilkår for henvisningsprogrammet",
        referrals: "Henvisninger",
        refresh: "Forfriske",
        regenerate: "Regenerer",
        reject_all: "Avvis alle",
        related_reviews: "Lignende Anmeldelser",
        related_similarity: "Likhet",
        remaining: "Gjenværende",
        reminder: "Påminnelse",
        reminders: "Påminnelser",
        remove: "Fjerne",
        remove_client: "Fjern Klient",
        remove_cname: "Fjern CNAME",
        remove_domain: "Fjern domene",
        remove_from_project: "Fjern fra prosjektet",
        remove_member: "Fjern medlem",
        remove_smtp_configuration: "Fjern SMTP konfigurasjon",
        remove_team_member: "Fjern teammedlem",
        rename: "Gi nytt navn",
        rename_template: "Gi malen nytt navn",
        renews: "Fornyer",
        replied: "Svarte",
        reply: "Svar",
        reply_to: "Svar til",
        replying_on: "Svarer på",
        request: "Forespørsel",
        request_date: "Forespørselsdato",
        request_review: "Be om en Anmeldelse",
        request_reviews: "Be om Anmeldelser",
        requested: "Forespurt",
        requested_review: "Forespurt Anmeldelse",
        requests: "Forespørsler",
        requests_left_this_month: "forespørsler igjen denne måneden",
        requests_remaining: "Gjenværende forespørsler",
        require_field: "Krev felt",
        require_subscription: "Kunden må ha et aktivt abonnement",
        required: "Obligatorisk",
        reschedule_message: "Planlegg melding på nytt",
        resend_invite: "Send invitasjonen på nytt",
        reset_password: "Tilbakestill passord",
        restore: "Restaurere",
        restore_to_defaults: "Gjenopprett til standardinnstillinger",
        restore_widget: "Gjenopprett widget",
        resubscribe: "Abonner på nytt",
        resubscribe_customer: "Abonner på nytt som kunde",
        resync: "Synkroniser på nytt",
        resync_account: "Synkroniser kontoen på nytt",
        resync_now: "Synkroniser på nytt nå",
        retries: "Nye forsøk",
        reveal_above_form: "Avslør skjemaet ovenfor",
        reveal_after_submission: "Avsløring etter innsending",
        reveal_below_form: "Avslør skjemaet nedenfor",
        review: "Anmeldelse",
        review_length: "Anmeldelseslengde",
        review_link: "Anmeldelseslenke",
        review_missed: "Anmeldelse mislyktes",
        review_not_requested: "Anmeldelse ikke forespurt",
        review_origin: "Denne anmeldelsen stammer fra malen",
        review_page: "Anmeldelsesside",
        review_pages: "Anmeldelsessider",
        review_requested: "Anmeldelse forespurt",
        review_spotlight: "Fremhevet anmeldelse",
        review_suggestion: "Forslag til Anmeldelse",
        review_suggestions: "Forslag til Anmeldelse",
        review_text: "Anmeldelse",
        review_wall: "Anmeldelsesvegg",
        reviewed: "Anmeldt",
        reviews: "Anmeldelser",
        reviews_ask: "Spørre",
        reviews_query_failed: "Noe gikk galt. Prøv igjen.",
        reviews_query_placeholder: "Søk etter anmeldelser eller still et spørsmål...",
        reviews_with_highlights: "Anmeldelser med høydepunkter",
        reviews_with_replies: "Anmeldelser med svar",
        reviews_without_replies: "Anmeldelser uten svar",
        revoke: "Tilbakekalling",
        revoke_client: "Tilbakekalling av appen",
        roadmap: "Veikart",
        role: "Rolle",
        sans_serif: "Sans Serif",
        save: "Lagre",
        save_preferences: "Lagre innstillinger",
        save_template: "Lagre",
        save_template_as_new: "Lagre ny mal",
        saved: "Lagret",
        schedule: "Planlegg",
        schedule_review_request: "Planlegg anmeldelsesforespørsel",
        scheduled: "Planlagt",
        score: "Poengsum",
        search: "Søk",
        second: "Sekund",
        secret_key: "Hemmelig nøkkel",
        sections: "Seksjoner",
        security_code: "Sikkerhetskode",
        select: "Velge",
        select_account: "Velg en konto",
        select_all: "Velg alle",
        select_an_option: "Velg et alternativ",
        select_bulk_action: "Velg massehandling",
        select_csv_file: "Velg CSV -fil",
        select_date: "Velg dato",
        select_field: "Velg et felt",
        select_icon: "Velg et ikon",
        select_location: "Velg en plassering",
        select_plan: "Velg en plan",
        select_review: "Velg en Anmeldelse",
        select_source: "Velg en kilde",
        select_tag: "Velg en Tagg",
        selected: "Valgt",
        send: "Sende",
        send_1_reminder: "Send 1 påminnelse",
        send_2_reminders: "Send 2 påminnelser",
        send_3_reminders: "Send 3 påminnelser",
        send_anytime: "Send når som helst",
        send_between: "Send mellom",
        send_message: "Send melding",
        send_retries: "Send {count} nye forsøk",
        send_retry: "Send {count} Prøv på nytt",
        send_test: "Send en test",
        send_thanks: "Send takk",
        sender_email_address: "Avsenderens e-postadresse",
        sender_id: "Avsender ID",
        sender_name: "Avsendernavn",
        sending_domain: "Sendende domene",
        sent: "Sendt",
        sent_replies: "Sendte svar",
        serif: "Serif",
        settings: "Innstillinger",
        share: "Dele",
        share_link: "Del Lenke",
        short: "Kort",
        show: "Vise",
        show_1_suggestion: "Vis ett forslag",
        show_100_results: "Vis 100 resultater",
        show_2_suggestions: "Vis to forslag",
        show_25_results: "Vis 25 resultater",
        show_3_suggestions: "Vis tre forslag",
        show_4_suggestions: "Vis fire forslag",
        show_5_suggestions: "Vis fem forslag",
        show_50_results: "Vis 50 resultater",
        show_all_reviews: "Vis alle anmeldelser",
        show_arrows: "Vis piler",
        show_avatar: "Vis avatar",
        show_cookie_consent_banner: "Vis banner for samtykke til informasjonskapsler",
        show_date: "Vis dato",
        show_dots: "Vis prikker",
        show_drop_shadow: "Vis skyggeeffekt",
        show_field: "Vis felt på følgende vurderinger",
        show_full: "Vis fulle stjerner",
        show_photo: "Vis kun bilde",
        show_positive_reviews: "Vis kun positive anmeldelser",
        show_to_public: "Vis til offentligheten",
        showcase: "Showcase",
        showcase_page: "Presentasjonsside",
        sign_up: "Registrer deg",
        sign_up_for_free: "Registrer deg gratis",
        sign_up_with_email: "Registrer deg med e-post",
        sign_up_with_google: "Registrer deg med Google",
        signature: "Signatur",
        signatures: "Signaturer",
        signed_up: "Registrert",
        since: "Siden",
        size: "Størrelse",
        skip: "Hopp over",
        slug: "Slug",
        small: "Liten",
        sms: "SMS",
        smtp_configuration: "SMTP konfigurasjon",
        sort: "Sortere",
        source: "Kilde",
        source_code: "Kildekode",
        sources: "Kilder",
        space: "Arbeidsområde",
        space_name: "Arbeidsområde",
        spaces: "Arbeidsområder",
        split: "Dele",
        star_color: "Stjernefarge",
        stars: "Stjerner",
        start: "Start",
        start_free_trial: "Start gratis prøveperiode",
        start_getting_more_reviews: "Begynn å få flere Anmeldelser",
        status: "Status",
        store_code: "Butikkkode",
        strategy: "Strategi",
        sub_processors: "Underdatabehandlere",
        subject: "Emne",
        subscribe: "Abonner",
        subscription: "Abonnement",
        success_page: "Suksessside",
        suggestion: "Forslag",
        suggestions: "Forslag",
        summary: "Sammendrag",
        support: "Support",
        suspend: "Suspender",
        suspend_project: "Stopp prosjektet",
        suspended: "Suspendert",
        svg: "SVG",
        switch_to_smtp_setup: "Bytt til SMTP oppsett",
        switch_to_standard_setup: "Bytt til standardoppsett",
        symbol: "Symbol",
        sync: "Synkroniser",
        sync_account: "Synkroniser konto",
        sync_now: "Synkroniser nå",
        sync_scheduled_time: "Synkronisering planlagt {time}",
        synced_time: "Synkronisert {time}",
        system: "System",
        system_fonts: "Systemfonter",
        tag: "Tagg",
        tag_1_customer: "Tagg 1-kunde",
        tag_1_review: "Tagg 1 Anmeldelse",
        tag_customers: "Tagg kunder",
        tag_existing_reviews: "Tagg eksisterende Anmeldelser",
        tag_n_customers: "Tagg {count} Kunder",
        tag_n_reviews: "Tagg {count} Anmeldelser",
        tag_reviews: "Tagg anmeldelser",
        tag_rule: "Taggregel",
        tag_with_ai: "Tagg med AI",
        tags: "Tagger",
        tags_for_customers: "Tagger for kunder",
        tags_for_reviews: "Tagger for Anmeldelser",
        team: "Team",
        team_member: "Teammedlem",
        team_members: "Teammedlemmer",
        template: "Mal",
        templates: "Maler",
        terms_of_service: "Vilkår for bruk",
        test_template: "Testmal",
        tests: "Tester",
        text: "Tekst",
        text_alignment: "Tekstjustering",
        text_color: "Tekstfarge",
        thank_you_messages: "Takkmeldinger",
        thanks: "Takk",
        theme: "Tema",
        third: "Tredje",
        time_zone: "Tidssone",
        timeframe: "Tidsramme",
        title: "Tittel",
        tone: "Tone",
        top: "Topp",
        top_left: "Øverst til venstre",
        top_right: "Øverst til høyre",
        total_charges: "Totale kostnader",
        total_reviews: "Totalt Anmeldelser",
        trigger: "Utløser",
        trigger_charged: "Send forespørsel etter en belastning",
        trigger_created: "Send forespørsel etter registrering",
        try_free: "Prøv gratis",
        try_it_free: "Prøv det gratis",
        type: "Type",
        types: "Typer",
        unarchive: "Fjern arkivet",
        unarchive_customer: "Fjern kunde fra arkivet",
        underline: "Understrek",
        unflag_as_duplicate: "Fjern flagg som duplikat",
        unknown: "Ukjent",
        unnamed: "Navnløs",
        unpublish: "Avpubliser",
        unpublished: "Upublisert",
        unreplied: "Ubesvart",
        unsent_messages: "Usendte meldinger",
        unsubscribe: "Avslutt abonnementet",
        unsubscribe_customer: "Meld kunde av",
        unsubscribe_customers: "Avslutt abonnementet Kunder",
        unsubscribe_text: "Avmeldingstekst",
        unsubscribed: "Avmeldt",
        unsuspend: "Opphev suspendering",
        unsuspend_project: "Opphev stopp i prosjektet",
        unverified: "Ubekreftet",
        update: "Oppdatering",
        update_password: "Oppdater passord",
        update_plan: "Oppdater planen",
        update_share_template: "Oppdater mal",
        updated: "Oppdatert",
        updates: "Oppdateringer",
        upgrade: "Oppgrader",
        upgrade_for_more: "Oppgrader for mer",
        upgrade_to_use: "Oppgrader for å bruke denne funksjonen",
        upload: "Last opp",
        upload_csv: "Last opp CSV",
        upload_icon: "Last opp et ikon",
        url: "URL",
        use: "Bruk",
        use_filters_for_aggregate: "Bruk filtre for aggregert",
        user: "Bruker",
        user_id: "Bruker ID",
        user_info: "Brukerinformasjon",
        username: "Brukernavn",
        utc: "UTC",
        validate: "Valider",
        validate_customer_email: "Valider kundens e-postadresse",
        validation: "Validering",
        validations: "Valideringer",
        value: "Verdi",
        verify: "Verifisere",
        verify_email_address: "Bekreft e-postadresse",
        view: "Vis",
        view_all: "Vis alle",
        view_all_features: "Se alle funksjoner",
        view_available_fields: "Vis tilgjengelige felt",
        view_documentation: "Vis dokumentasjon",
        view_email_templates: "Vis e-postmaler",
        view_review_pages: "Vis Anmeldelsessider",
        view_reviews: "Se Anmeldelser",
        view_settings: "Vis innstillinger",
        view_setup_guide: "Se oppsettveiledningen",
        view_showcase: "Se utstilling",
        view_strategy: "Vis strategi",
        visibility: "Synlighet",
        visible: "Synlig",
        visible_reviews: "Synlige Anmeldelser",
        visible_to_search_engines: "Synlig for søkemotorer",
        wait_between_reminders: "Vent mellom påminnelser",
        wait_period: "Venteperiode",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Nettsted",
        weekly: "Ukentlig",
        weeks: "Uker",
        widget: "Widget",
        widgets: "Widgeter",
        with_ai: "med AI",
        worst_to_best: "Verst til best",
        write: "Skrive",
        written_reviews: "Skriftlige Anmeldelser",
        year: "år",
        yearly: "Årlig",
        yes: "Ja",
        your_referral_link: "Din henvisningslenke"
    },
    landing: {
        announcement: "Få omdømmerapporter med vår MCP-server",
        callout_1_subtitle: "Få tilgang til alle kjernefunksjonene i 7 dager gratis. Ingen kredittkort kreves. Begynn å få flere anmeldelser nå.",
        callout_1_title: "Gratis prøveperiode",
        callout_2_subtitle: "Importer kunder med Stripe, HubSpot, Zapier, CSV -opplasting, e-post BCC, API og mer.",
        callout_2_title: "Hurtigoppsett",
        callout_3_subtitle: "Du bestemmer hvem du vil sende til og når. Vi sender forespørsler om anmeldelser til kundene dine hver dag.",
        callout_3_title: "Automatisk",
        callout_4_subtitle: "Fang opp negative tilbakemeldinger før du ber kunder om å legge igjen offentlige anmeldelser.",
        callout_4_title: "Tilbakemeldingsruting",
        counter: "Bli med i over 5.000 lokale tjenestebedrifter",
        feature_1_subtitle: "Be kundene dine automatisk om anmeldelser – uten ekstra arbeid.",
        feature_1_title: "Forbedre omdømmet ditt",
        feature_2_subtitle: "Legg enkelt til dine eksisterende anmeldelser.",
        feature_2_title: "Importer Anmeldelser",
        feature_3_subtitle: "Vis enkelt anmeldelser på nettstedet ditt med fullt tilpassbare widgeter.",
        feature_3_title: "Vis frem Anmeldelser hvor som helst",
        feature_4_subtitle: "Tilpass e-post- og SMS -forespørsler og påminnelser slik at de samsvarer med merkevaren din.",
        feature_4_title: "Tilpassbare maler",
        feature_5_subtitle: "Angi det én gang, og la oss håndtere når forespørsler om Anmeldelse og påminnelser sendes.",
        feature_5_title: "Smart forespørselsplanlegging",
        feature_6_subtitle: "Samle inn anmeldelser fra tredjeparter eller private tilbakemeldinger – alt på din egen tilpassede side.",
        feature_6_title: "Personlig Anmeldelsesside",
        feature_7_subtitle: "Gjør det enklere for kunder å legge igjen gode anmeldelser med AI-drevne anmeldelsesforslag.",
        feature_7_title: "Forslag til AI- Anmeldelse",
        feature_8_subtitle: "Omdiriger kunder til alle anmeldelsesnettstedene dine fra én lenke eller QR-kode.",
        feature_8_title: "Samle Anmeldelser overalt",
        industries: {
            accountants: "Regnskapsførere",
            auto_repair: "Bilverksteder",
            chiropractors: "Kiropraktorer",
            cleaning: "Rengjøringstjenester",
            coaching: "Coaching",
            contractors: "Entreprenører",
            dentists: "Tannleger",
            doctors: "Leger",
            education: "Utdanning",
            electricians: "Elektrikere",
            financial_advisors: "Finansielle rådgivere",
            fitness: "Trening",
            hvac: "VVS",
            insurance: "Forsikringsbyråer",
            landscapers: "Anleggsgartnere",
            law_firms: "Advokatfirmaer",
            locksmiths: "Låsesmeder",
            mortgage_brokers: "Meglere for boliglån",
            optometrists: "Optikere",
            pest_control: "Skadedyrkontroll",
            physical_therapy: "Fysioterapi",
            plumbers: "Rørleggere",
            real_estate: "Eiendom",
            restaurants: "Restauranter",
            roofers: "Taktekker",
            salons: "Salonger",
            self_storage: "Self-storage",
            spas: "Spa",
            veterinarians: "Veterinærer",
        },
        industries_label: "Laget for lokale tjenestebedrifter",
        subtitle: "Be om anmeldelser på autopilot. Få flere 5-stjerners vurderinger. Ranger høyere enn konkurrentene dine.",
        title: "AI-omdømmehåndtering for å",
        title_phrases: {
            google_reviews: "få flere Google-anmeldelser",
            autopilot: "be om anmeldelser automatisk",
            suggested_by_chatgpt: "bli foreslått av ChatGPT"
        },
        title_contact: "Hvordan kan vi hjelpe?",
        title_faq: "Vanlige spørsmål",
        title_features: "Alt-i-ett-verktøysettet for å be om og vise frem anmeldelser",
        title_footer: "Slutt å jage anmeldelser. Begynn å få dem.",
        title_integrations: "Integrasjoner",
        title_ltd: "Betal én gang og bruk for alltid med vår tidsbegrensede livstidsavtale",
        title_pricing: "Alle funksjoner. Enkel prissetting.",
        title_reviews: "Se hvorfor vi er rangert som #1 innen anmeldelsesadministrasjon",
    },
    plans: {
        agency: {
            agency_api: "Byrå API",
            branded_portal: "Merkevarebasert klientportal",
            client_invites: "Klient , roller og overstyringer",
            custom_domain: "Tilpasset byrådomene",
            everything_in_business: "Alt i forretningsplanen",
            locations_included: "5 steder inkludert",
            review_requests: "5000 anmeldelsesforespørsler \/ sted \/ måned",
            support: "Dedikert kundestøtte",
            volume_pricing: "Volumpriser fra 49 dollar\/mnd."
        },
        business: {
            ai: "AI-svar, innsikt og Ask AI",
            api_mcp: "API og MCP Server",
            custom_domains: "Tilpassede e-post- og anmeldelsessidedomener",
            google_facebook: "Google Bedriftsprofil og Facebook",
            locations_included: "1 lokasjon inkludert",
            review_requests: "{count} forespørsler om gjennomgang \/ sted \/ måned",
            support: "Dedikert kundestøtte",
            unlimited_customers: "Ubegrensede kunder",
            volume_pricing: "Volumpriser fra 99 dollar\/mnd."
        },
        selectors: {
            agency_included: "{count} Inkluderte steder",
            agency_tier: "+{from}–{to} plasseringer · {price}\/{month} hver",
            agency_tier_plus: "+{from}+ lokasjoner · {price}\/{month} hver",
            business_tier: "{from}–{to} lokasjoner · {price}\/{month} hver",
            business_tier_plus: "{from}+ lokasjoner · {price}\/{month} hver"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Legg til en kunde og be om en anmeldelse",
            customers_to_ask: "Finn kunder å be om anmeldelser",
            location_leaderboard: "Sammenlign ytelsen til lokasjonen",
            outreach_health: "Revider leveringskvaliteten for forespørsler",
            review_digest: "Ukentlig oversiktssammendrag",
            send_review_requests: "Send forespørsler om Anmeldelse i bulk"
        },
        texts: {
            add_customer_and_ask: "Legg til en ny kunde ved hjelp av kontaktinformasjonen jeg gir deg, og bestill deretter en Anmeldelsesforespørsel for dem via e-post med to påminnelser.",
            customers_to_ask: "List opp opptil 50 kunder som aldri har blitt bedt om en anmeldelse, sortert etter registreringsdato med den nyeste først. Hopp over alle som har avsluttet abonnementet. Ta med navn, e-post og registreringsdato.",
            location_leaderboard: "Lag en 90-dagers ledertavle etter sted med antall anmeldelser, gjennomsnittlig vurdering, prosent 5-stjerners og trend sammenlignet med de foregående 90 dagene. Sorter etter vurdering og flagg eventuelle fall over 0,2 stjerner.",
            outreach_health: "For e-poster sendt de siste 14 dagene, rapporter totalt antall sendte e-poster, leveringsfrekvens, åpningsfrekvens, klikkfrekvens og feilfrekvens. Flagg eventuelle avvik.",
            review_digest: "Oppsummer alle anmeldelser fra de siste 7 dagene. Inkluder antall, gjennomsnittlig vurdering, fordeling etter kilde og sted, de tre viktigste temaene og de tre viktigste bekymringene.",
            send_review_requests: "For kunder som har registrert seg i løpet av de siste 30 dagene og ikke har blitt spurt, bestill en Anmeldelsesforespørsel via e-post med to påminnelser. Vis listen først og vent på bekreftelsen min."
        }
    },
    messages: {
        activated: "Vellykket aktivert.",
        archived: "Arkivert.",
        canceled: "Avlyst.",
        cannot_copy: "Kan ikke kopiere til utklippstavlen",
        cname_active: "CNAME statusen er aktiv.",
        cname_not_active: "CNAME statusen er ikke aktiv ennå.",
        connected: "Tilkoblingen er vellykket.",
        cookie_banner_text: "Vi bruker informasjonskapsler for å forbedre opplevelsen din. Du kan tilpasse preferansene dine eller godta alle.",
        cookie_category_analytics_desc: "Brukes til å måle nettstedstrafikk og produktbruk. Disse informasjonskapslene hjelper oss å forstå hvordan besøkende bruker nettstedet vårt.",
        cookie_category_essential_desc: "Alltid aktive. Disse informasjonskapslene er nødvendige for at nettstedet skal fungere og kan ikke slås av.",
        cookie_category_functional_desc: "Aktiver forbedrede funksjoner som live chat. Disse informasjonskapslene sporer deg ikke for reklameformål.",
        cookie_category_marketing_desc: "Brukes til annonsering og kampanjemåling. Disse kan inkludere annonsepiksler og attribusjonsverktøy.",
        copied: "Kopiert.",
        created: "Opprettet.",
        deactivated: "Deaktivert.",
        deleted: "Slettet.",
        disconnected: "Frakoblingen er vellykket.",
        duplicated: "Duplisert.",
        error: "Noe gikk galt. Prøv igjen.",
        google_connect_failed: "Vi kunne ikke koble til Google. Du kan prøve på nytt eller hoppe over dette foreløpig.",
        oauth_consent_intro: "{client} ber om tillatelse til å få tilgang til kontoen din.",
        oauth_request_missing: "OAuth-autorisasjonsforespørselen mangler eller er utløpt.",
        operation_connection_sync_failed: "{integration_name} synkronisering mislyktes.",
        operation_connection_sync_progress: "Synkroniserer {integration_name}…",
        operation_connection_sync_success: "{integration_name} synkronisering fullført.",
        operation_customer_import_failed: "Kunde mislyktes.",
        operation_customer_import_progress: "Importerer kunder …",
        operation_customer_import_success: "Kunde fullført.",
        operation_review_import_failed: "Import av Anmeldelse mislyktes.",
        operation_review_import_progress: "Importerer anmeldelser…",
        operation_review_import_success: "Import av Anmeldelse fullført.",
        operation_review_scrape_failed: "Import av nylig anmeldelse mislyktes.",
        operation_review_scrape_progress: "Importerer nylige anmeldelser…",
        operation_review_scrape_success: "Import av nylig anmeldelse fullført.",
        processed: "Vellykket behandlet.",
        published: "Publisert.",
        purchased: "Kjøpt.",
        queued: "Planlagt.",
        refreshed: "Oppdatert.",
        removed: "Fjernet.",
        resubscribed: "Abonnementet er på nytt.",
        revoked: "Opphevet.",
        saved: "lagret.",
        scheduled: "Planlagt.",
        sent: "Sendt.",
        started: "Vellykket startet.",
        stopped: "Stoppet.",
        subscribed: "Abonnementet er fullført.",
        suspended: "Suspendert.",
        synced: "Synkronisert.",
        unarchived: "Arkiveringen er vellykket avsluttet.",
        unpublished: "Avpubliseringen er vellykket.",
        unscheduled: "Avplanlagt.",
        unsubscribed: "Abonnementet er avsluttet.",
        unsuspended: "Suspensjonen er opphevet.",
        updated: "Oppdatert.",
        upgraded: "Oppgradert.",
        validated: "Validert.",
        verified: "Verifisert."
    },
    notices: {
        agency: "Driver du et byrå? Du kan sette white label på produktet vårt, slik at kundene dine bare ser merkevaren din når de bruker tjenesten.",
        connected_apps: "Apper du kobler til via MCP vises her.",
        connector: "Importer kundene dine fra tusenvis av applikasjoner med {brand}.",
        customer_messages: "Be om en Anmeldelse for å planlegge meldinger.",
        customer_reviews: "Be om en anmeldelse fra denne kunden.",
        customers: "Importer kundene dine for å begynne å be om anmeldelser.",
        external_links: "Legg til eksterne lenker i kundeportalen din for å hjelpe deg med å selge tjenestene dine. Disse lenkene vises til kundene dine i sidefeltet.",
        links: "Legg til knapper på siden din for å legge igjen anmeldelser på tredjepartsnettsteder.",
        locations: "Opprett en lokasjon slik at du kan tilskrive anmeldelser til flere lokasjoner.",
        ltd: "Lås opp livstidsadgang med tilgangskoden din. Hver kode kommer med et begrenset antall månedlige forespørsler, pluss alle funksjoner. Kodene kan stables. 3 koder fjerner all merkevarebyggingen vår og låser opp byråfunksjoner. Skriv inn tilgangskoden din nedenfor.",
        mcp_example_prompts: "Når MCP server er tilkoblet, limer du disse inn i assistenten som et utgangspunkt.",
        messages: "Alle forespørsler og påminnelser vil vises her når kundene dine ber om anmeldelser .",
        no_commissions: "Du har ikke opptjent noen provisjoner ennå.",
        no_payouts: "Utbetalinger sendes manuelt når den godkjente saldoen din når minst 50,00 dollar og bankkontoen din er tilkoblet.",
        no_referrals: "Du har ikke henvist noen ennå. Del henvisningslenken din for å komme i gang.",
        projects: "Det er ingen prosjekter ennå.",
        qr_codes: "Lag QR-koder med egendefinerte farger, plasseringer og tagger. Last ned som SVG eller PNG.",
        referrals_share_subject: "Min AI-omdømmehåndtering",
        referrals_share_text: "Mitt hemmelige våpen for å få anmeldelser: More Good Reviews. Omdømmehåndtering med kunstig intelligens som faktisk fungerer. Registrer deg med lenken min:",
        review_pages: "Prosjektet ditt kan ha flere anmeldelsessider der kundene dine kan legge igjen anmeldelser. Dette er nyttig for bedrifter med mer enn én lokasjon.",
        reviews: "Vi venter på anmeldelser fra kundene dine.",
        showcase: "Vi har akkurat begynt.",
        signatures: "Lag en e-postsignatur som du kan kopiere og lime inn i e-postprogrammet ditt.",
        sources: "Opprett en kilde slik at du kan kategorisere anmeldelser dine.",
        tag_rules: "Opprett en regel for å kategorisere anmeldelser dine automatisk med AI.",
        tags: "Opprett en tagg for å kategorisere anmeldelser og kundene dine.",
        unauthorized: "Du har ikke tillatelse til å få tilgang til denne siden.",
        unsubscribed: "Du er nå avmeldt forespørsler om anmeldelser.",
        webhooks: "Legg til webhooks for å bli varslet om plattformhendelser.",
        widgets: "Lag widgeter for å legge inn anmeldelser på nettstedet ditt.",
        your_referral_link_text: "Del lenken din for å tjene {rate} % gjentakende provisjon på hver betaling fra kunder du henviser. Utbetalinger sendes manuelt når den godkjente saldoen din når minst $50,00."
    },
    notification_types: {
        descriptions: {
            imports: "Sendes når importen er fullført",
            new_reviews: "Sendes når anmeldelser er mottatt",
            sent_replies: "Sendes når anmeldelser besvares automatisk",
            weekly_reports: "Et sammendrag av aktiviteten sendes ukentlig"
        },
        names: {
            imports: "Import",
            new_reviews: "Nye Anmeldelser",
            sent_replies: "Sendte svar",
            weekly_reports: "Ukentlige rapporter"
        }
    },
    roles: {
        manager: "Leder",
        operator: "Operatør",
        owner: "Eier",
        super_admin: "Admin",
        viewer: "Seer"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Godta invitasjonen",
        accepting_invite: "Godtar invitasjonen",
        access_denied: "Tilgang nektet",
        account: "Konto",
        actions: "Handlinger",
        add_custom_field: "Legg til tilpasset felt",
        add_ons: "Tillegg",
        address: "Adresse",
        agency: "Byrå",
        ai_assistant: "AI-assistent",
        ai_highlights: "AI-høydepunkter",
        ai_replies: "AI-svar",
        ai_review_suggestions: "Forslag til AI- Anmeldelse",
        analytics: "Analyse",
        api: "API",
        api_key: "API nøkkel",
        appearance: "Utseende",
        application_connectors: "Applikasjonskoblinger",
        attributes: "Attributter",
        authorize: "Autorisere",
        auto_tagging: "Automatisk tagging",
        automatic_review_collection: "Automatisk innsamling av Anmeldelse",
        billing: "Fakturering",
        branding: "Merkevarebygging",
        change_password: "Endre passord",
        clients: "Klienter",
        cname: "CNAME",
        conditions: "Betingelser",
        connected_apps: "Tilkoblede apper",
        contact_us: "Kontakt oss",
        cookie_policy: "Informasjonskapsler",
        cookie_preferences: "Informasjonskapsler",
        copy: "Kopiere",
        create_your_account: "Opprett kontoen din",
        crms: "CRM-systemer",
        css: "CSS",
        custom_field: "Tilpasset felt",
        custom_fields: "Tilpassede felt",
        custom_icons: "Tilpassede ikoner",
        customer: "Kunde",
        customer_facing_pages: "Kundevendte sider",
        customers: "Kunder",
        dashboard: "Kontrollpanel",
        details: "Detaljer",
        dmarc: "DMARC",
        domain: "Domene",
        dpa: "Databehandleravtale",
        dsar: "Forespørsel om tilgang til data",
        email_address: "E-postadresse",
        email_messages: "E-postmeldinger",
        email_settings: "E-postinnstillinger",
        email_usage: "E-postbruk",
        emails: "E-poster",
        embed_code: "Innbyggingskode",
        examples: "Eksempler",
        export: "Eksport",
        external_link: "Ekstern Lenke",
        external_link_num: "Ekstern Lenke #{num}",
        external_links: "Eksterne Lenker",
        field: "Felt",
        fields: "Felt",
        filters: "Filtre",
        form_fields: "Skjemafelt",
        got_access_code: "Har du en tilgangskode?",
        how_it_works: "Hvordan det fungerer",
        incentive: "Insentiv",
        instructions: "Instruksjoner",
        integration: "Integrering",
        integrations: "Integrasjoner",
        javascript: "JavaScript",
        latest_reviews: "Siste Anmeldelser",
        lifetime_deal: "Livstidsavtale",
        limits: "Grenser",
        link: "Lenke",
        links: "Lenker",
        location: "Sted",
        location_picker: "Stedsvelger",
        locations: "Steder",
        log_in: "Logg inn",
        log_out: "Logg ut",
        make_default: "Gjør til standard",
        manage_limits: "Administrer grenser",
        manage_overrides: "Administrer overstyringer",
        manage_review: "Administrer Anmeldelse",
        mcp_example_prompts: "Eksempel på spørsmål",
        mcp_server: "MCP Server",
        message: "Beskjed",
        messages: "Meldinger",
        meta: "Meta",
        no_clients: "Ingen klienter",
        no_commissions: "Ingen provisjoner",
        no_connected_apps: "Ingen tilkoblede apper",
        no_custom_fields: "Ingen egendefinerte felt",
        no_customers: "Ingen kunder",
        no_links: "Ingen Lenker",
        no_locations: "Ingen steder",
        no_members: "Ingen medlemmer",
        no_messages: "Ingen meldinger",
        no_payouts: "Ingen utbetalinger",
        no_projects: "Ingen prosjekter",
        no_qr_codes: "Ingen QR-koder",
        no_referrals: "Ingen henvisninger",
        no_review_pages: "Ingen Anmeldelsessider",
        no_reviews: "Ingen Anmeldelser",
        no_tags: "Ingen Tagger",
        no_team_members: "Ingen teammedlemmer",
        no_template: "Ingen mal",
        no_widgets: "Ingen widgeter",
        notifications: "Varsler",
        options: "Alternativer",
        overview: "Oversikt",
        payment_method: "Betalingsmåte",
        photo: "Foto",
        plans: "Planer",
        powered_by: "Drevet av",
        pricing: "Prissetting",
        privacy_policy: "Personvernerklæring",
        profile: "Profil",
        project: "Prosjekt",
        project_limits: "Prosjektgrenser",
        project_overrides: "Prosjektoverstyringer",
        projects: "Prosjekter",
        qr_code: "QR-kode",
        qr_codes: "QR-koder",
        ratings: "Vurderinger",
        redeem_access_code: "Løs inn tilgangskode",
        redirecting: "Omdirigerer",
        redirects: "Omdirigeringer",
        referrals_commissions: "Provisjoner",
        referrals_payouts: "Utbetalinger",
        referral_program: "Vilkår for henvisningsprogrammet",
        reminders: "Påminnelser",
        reply: "Svar",
        request: "Forespørsel",
        request_options: "Forespørselsalternativer",
        requests: "Forespørsler",
        required: "Obligatorisk",
        reschedule_message: "Planlegg melding på nytt",
        reset_password: "Tilbakestill passord",
        retries: "Nye forsøk",
        review: "Anmeldelse",
        review_link: "Anmeldelseslenke",
        review_page: "Anmeldelsesside",
        review_pages: "Anmeldelsessider",
        review_spotlight: "Fremhevet anmeldelse",
        review_suggestions: "Forslag til Anmeldelse",
        review_wall: "Anmeldelsesvegg",
        reviewer: "Anmelder",
        reviews: "Anmeldelser",
        save_changes: "Lagre endringer",
        schedule: "Rute",
        scrape_a_website: "Skrap et nettsted",
        search_engines: "Søkemotorer",
        sections: "Seksjoner",
        select_csv_file: "Velg CSV -fil",
        selecting_project: "Velge prosjekt",
        sending_domain: "Sendende domene",
        sending_limits: "Sendegrenser",
        settings: "Innstillinger",
        setup: "Oppsett",
        setup_basics: "Din Forespørsel",
        setup_business: "La oss komme i gang",
        setup_google: "Din Google -bedriftsprofil",
        setup_trusted: "Stolt på av over 5000 bedrifter",
        showcase: "Showcase",
        sign_up: "Registrer deg",
        signature: "Signatur",
        signatures: "Signaturer",
        signing_in: "Logger inn",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "SMS -meldinger",
        sms_usage: "SMS -bruk",
        smtp_configuration: "SMTP konfigurasjon",
        source: "Kilde",
        sources: "Kilder",
        space: "Arbeidsområde",
        spaces: "Arbeidsområder",
        stats: "Statistikk",
        sub_processors: "Underdatabehandlere",
        success_page: "Suksessside",
        summary: "Sammendrag",
        tag: "Tagg",
        tag_rule: "Taggregel",
        tags: "Tagger",
        team_members: "Teammedlemmer",
        template: "Mal",
        templates: "Maler",
        terms_of_service: "Vilkår for bruk",
        two_factor_authentication: "Tofaktorautentisering",
        unable_to_complete_request: "Kan ikke fullføre forespørselen",
        unique_review_link: "Unik anmeldelseslenke",
        unsent_messages: "Usendte meldinger",
        unsubscribe: "Avslutt abonnementet",
        update_plan: "Oppdater planen",
        usage: "Bruk",
        user: "Bruker",
        user_info: "Brukerinformasjon",
        verify_email_address: "Bekreft e-postadresse",
        verifying_email: "Bekrefter e-post",
        visibility: "Synlighet",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Nettsted",
        white_label_api: "Hvit etikett API",
        white_label_client_portal: "White Label-klientportal",
        white_label_image_urls: "URL-er for hvite etiketter for bilder",
        white_label_sending_domain: "Hvitmerket sendedomene",
        white_label_widget_tag: "White Label Widget- Tagg",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgeter",
        your_plan: "Din plan"
    },
    tones: {
        apologetic: "Unnskyldende",
        casual: "Tilfeldig",
        empathetic: "Empatisk",
        enthusiastic: "Entusiastisk",
        formal: "Formell",
        friendly: "Vennlig",
        grateful: "Takknemlig",
        humorous: "Humoristisk",
        informative: "Informativ"
    },
    widgets: {
        labels: {
            alignment: "Justering",
            animation: "Animasjon",
            autoplay: "Autospill",
            autoplay_delay: "Forsinkelse i automatisk avspilling",
            avatar: "Avatar",
            background_color: "Bakgrunnsfarge",
            border: "Grense",
            border_color: "Kantfarge",
            border_radius: "Kanteradius",
            border_width: "Kantbredde",
            carousel: "Karusell",
            colors: "Farger",
            company: "Bedrift",
            customer: "Kunde",
            customer_position: "Kundeposisjon",
            date: "Dato",
            delay: "Utsette",
            drop_shadow: "Skyggeeffekt",
            duration: "Varighet",
            filters: "Filtre",
            font: "Skrifttype",
            font_emphasis: "Skriftvekt",
            font_family: "Skriftfamilie",
            font_size: "Skriftstørrelse",
            include_hidden: "Inkluder skjulte Anmeldelser",
            layout: "Oppsett",
            limit: "Anmeldelser per side",
            location_ids: "Steder",
            marquee: "Marquee",
            max_slides: "Maks. antall lysbilder",
            max_width: "Maks. bredde",
            name_convention: "Navn",
            padding: "Polstring",
            pagination: "Paginering",
            quotes: "Sitater",
            rating: "Vurdering",
            rating_round: "Avrunding",
            rating_round_hundredth: "Nærmeste hundredel (4,94)",
            rating_round_tenth: "Nærmeste tiendedel (4,9)",
            review: "Anmeldelse",
            review_chars: "Anmeldelse",
            review_count: "Antall Anmeldelse",
            review_id: "Anmeldelse",
            review_ids: "Anmeldelser",
            review_ids_for_faces: "Anmeldelser for Ansikter",
            reviews: "Anmeldelser",
            schema: "Schema",
            schema_name: "Firmanavn",
            schema_type: "Bedriftstype",
            score: "Laveste vurdering",
            show_on_mobile: "Vis på mobil",
            slider: "Glidebryter",
            source: "Kilde",
            source_ids: "Kilder",
            source_position: "Kildeposisjon",
            speed: "Fart",
            star_color: "Stjernefarge",
            star_display: "Stjernevisning",
            star_size: "Stjernestørrelse",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Tagger",
            take: "Maksimalt antall Anmeldelser",
            text_color: "Tekstfarge",
            truncate: "Forkort Anmeldelse",
            visible_slides: "Synlige lysbilder",
            width: "Bredde"
        },
        types: {
            badge: "Skilt",
            carousel: "Karusell",
            carousel_dynamic: "Dynamisk karusell",
            corner: "Hjørne",
            corner_dynamic: "Dynamisk hjørne",
            faces: "Ansikter",
            headline: "Overskrift",
            highlights: "Høydepunkter",
            marquee: "Marquee",
            spotlight: "Fremhevet",
            wall: "Vegg"
        }
    }
}